import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

// Initialize Firebase
const {
  VUE_APP_FIREBASE_API_KEY: apiKey,
  VUE_APP_FIREBASE_PROJECT_ID: projectId
} = process.env;

firebase.initializeApp({
  apiKey,
  projectId,
  storageBucket: `${projectId}.appspot.com`,
});

export default firebase;
